<div class="main-div">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>Attività</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>
        La nostra Azienda offre la più ampia disponibilità nel campo
        impiantistico, dagli impianti elettrici di potenza per grandi gruppi
        agli impianti più specifici e dedicati per attività commerciali, uffici,
        terziario.
      </p>
      <p>Ecco alcuni dei servizi che offriamo:</p>
      <ul>
        <li>Impianti elettrici industriali e manutenzione</li>
        <li>Quadri di distribuzione B.T.</li>
        <li>Sistemi di rifasamento</li>
        <li>Illuinotecnica</li>
        <li>Impianti rilevazione incendio</li>
        <li>Impianti antintrusione</li>
        <li>Impianti viseosorveglianza</li>
        <li>Controllo accessi</li>
        <li>Adeguamento impianti elettrici</li>
        <li>Manutenzioni complessi residenziali</li>
        <li>Domotica</li>
        <li>Trasmissione dati</li>
        <li>Cablaggi strutturati reti</li>
        <li>Condizionamento</li>
        <li>Automazione cancelli</li>
        <li>Impianti citofonici</li>
        <li>Impianti elettrici di distribuzione luce e forza</li>
        <li>Impianti illuminazione uffici</li>
        <li>Impianti sicurezza</li>
        <li>Impianti rete cablata fonia/dati</li>
        <li>Audiovisivi</li>
      </ul>
    </mat-card-content>
  </mat-card>
</div>
